<template>
  <div>
    <topbar
      :titulo="$t('ACADEMICO.PAINEL_PROFESSOR')"
      :subtitulo="$t('ACADEMICO.PAINEL_PROFESSOR_DESCRICAO')"
      :breadcrumbs="breadcrumbs"
    />

    <filtro @filtrar="filtrar" @limparFiltro="filtrar" />

    <tabela
      class="mt-4"
      :items="resultadoBusca"
      :parametroAnoLetivo="parametroAnoLetivo"
      :segmentacoes="segmentacaoSelecionado"
      @recuperacaoSegmentacao="openModal"
      @avaliacaoFinal="openModal"
      @frequencia="openModal"
      @nota="openModal"
      @pontosAdicionais="openModal"
      @parecerDescritivo="openModal"
      @alterar-ordenacao="novaOrdenacao"
    />
    
    <paginacao
      v-model="paginacao"
      :total="paginacao.total"
      @input="filtrar(filtro)"
    />

    <modal-frequencia
      :exibir="modais.frequencia"
      :form="modais.frequenciaDados"
      :filtro="filtro"
      @fechar="closeModal('frequencia')"
    />

    <modal-recuperacao-segmentacao
      :exibir="modais.recuperacaoSegmentacao"
      :form="modais.recuperacaoSegmentacaoDados"
      @fechar="closeModal('recuperacaoSegmentacao')"
    />

    <modal-avaliacao-final
    :exibir="modais.avaliacaoFinal"
    :form="modais.avaliacaoFinalDados"
    @fechar="closeModal('avaliacaoFinal')"
    />

    <modal-nota
      :exibir="modais.nota"
      :formDados="modais.notaDados"
      :filtro="filtro"
      @fechar="closeModal('nota')"
    />

    <modal-pontos-adicionais
      :exibir="modais.pontosAdicionais"
      :form="modais.pontosAdicionaisDados"
      @fechar="closeModal('pontosAdicionais')"
    />

    <modal-parecer-descritivo
      :exibir="modais.parecerDescritivo"
      :form="modais.parecerDescritivoDados"
      :disciplina-id="filtro.disciplinaId"
      @fechar="closeModal('parecerDescritivo')"
    />
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import modais from '@/common/utils/modais';
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';

// Services:
import TurmaDisciplinaService from '@/common/services/turma-disciplina/turma-disciplina.service';

// Components:
import Filtro from './components/Filtro.vue';
import Tabela from './components/Tabela.vue';
import ModalNota from './components/ModalNota/Modal.vue';
import ModalFrequencia from './components/ModalFrequencia/Modal.vue';
import ModalPontosAdicionais from './components/pontos-adicionais/ModalPontosAdicionais.vue';
import ModalRecuperacaoSegmentacao from '@/views/academico/painel-professor/components/ModalRecuperacaoSegmentacao/Index.vue';
import ModalAvaliacaoFinal from '@/views/academico/painel-professor/components/ModalAvaliacaoFinal/Index.vue';
import ModalParecerDescritivo from './components/parecer-descritivo/ModalParecerDescritivo.vue';
import Paginacao from '@/components/paginacao/Paginacao';

export default {
  components: {
    Topbar,
    Filtro,
    Tabela,
    ModalFrequencia,
    ModalNota,
    ModalPontosAdicionais,
    ModalRecuperacaoSegmentacao,
    ModalAvaliacaoFinal,
    ModalParecerDescritivo,
    Paginacao,
  },
  data() {
    return {
      resultadoBusca: [],
      filtro: {},
      parametroAnoLetivo: '',
      segmentacaoSelecionado: {},
      modais: {
        nota: false,
        notaDados: {},
        frequencia: false,
        frequenciaDados: {},
        pontosAdicionais: false,
        pontosAdicionaisDados: {},
        parecerDescritivo: false,
        parecerDescritivoDados: {},
        recuperacaoSegmentacao: false,
        recuperacaoSegmentacaoDados: {},
        avaliacaoFinal: false,
        avaliacaoFinalDados: {}
      },
      breadcrumbs: [
        { titulo: this.$t('ACADEMICO.ACADEMICO') },
        { titulo: this.$t('PAINEL_PROFESSOR.PAINEL_PROFESSOR') },
      ],
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      },
      campoOrdenado: null,
      ordem: false,
    };
  },
  methods: {
    // FUNÇÕES FILTRO
    filtrar({ filtro, segmentacao }) {
      this.filtro = filtro;
      this.segmentacaoSelecionado = segmentacao;

      if (filtro?.limpeza) {
        this.resultadoBusca = [];
        return;
      }

      this.obterPorFiltro();
    },
    obterPorFiltro() {
      this.parametroAnoLetivo = this.filtro.anoLetivoId;
      this.$store.dispatch(START_LOADING);
      TurmaDisciplinaService.obterPorFiltro(
        this.filtro,
        this.paginacao,
        this.campoOrdenado,
        this.ordem
      )
        .then((result) => {
          this.resultadoBusca = result.data.itens;
          console.log(this.resultadoBusca);
          this.paginacao.total = result.data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    // FUNÇÕES MODAL
    openModal(key, item) {
      return modais.abrirModal(this, key, item);
    },
    closeModal(key) {
      return modais.fecharModal(this, key);
    },
    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = ordem;
      this.obterPorFiltro();
    },
  },
};
</script>
